<template>
  <DataIterat
    :headless="fetching"
    searchable
    :filterable="meta && meta.last_page !== 1"
    :filter-presets="filterPresets"
    :paginatable="meta && meta.last_page !== 1"
    v-bind="{ items: facebookCampaigns, loading: fetching, meta }"
    v-on="{ getData: getFacebookCampaigns }"
  >
    <DataIteratHeaderContent slot="list-header-content" />
    <DataIteratItemContent
      slot="list-item-content"
      slot-scope="{ dataItem: facebookCampaign }"
      :facebook-campaign="facebookCampaign"
      :lifetime-insights="entityById('facebookLifetimeInsights', facebookCampaign.lifetimeInsights)"
    />
    <template slot="list-item-actions" slot-scope="{ dataItem: facebookCampaign, onClick }">
      <slot name="item-actions" :facebook-campaign="facebookCampaign" :close-action="onClick" />
    </template>
  </DataIterat>
</template>

<script>
import DataIterat from '@/components/Ui/DataIterat.vue';
import { entityComputed } from '@/store/helper';
import DataIteratHeaderContent from './DataIteratHeaderContent.vue';
import DataIteratItemContent from './DataIteratItemContent.vue';

export default {
  name: 'FacebookCampaignList',
  components: {
    DataIterat,
    DataIteratHeaderContent,
    DataIteratItemContent,
  },
  props: {
    fetching: Boolean,
    filterPresets: {
      type: Array,
      default: () => [],
    },
    facebookCampaigns: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...entityComputed,
  },
  methods: {
    getFacebookCampaigns(queryParams = {}) {
      this.$emit('get-facebook-campaigns', queryParams);
    },
  },
};
</script>
